<template>
  <router-view/>
</template>


<script setup>
import { onMounted, onUnmounted } from 'vue';
import { useRouter } from 'vue-router';
import mitt from '@/utils/bus.js'
const router = useRouter();

function handleMessage(event) {
  if (event.data.type === "changeTab") {
    switch (event.data.data) {
      case "grapeModel":
        router.push('/model');
		mitt.emit('Changerouter', 1);
        break;
      case "plantMonitor":
        router.push('/');
		mitt.emit('Changerouter', 0);
        break;
      default:
        console.log("Unknown data:", event.data.data);
    }
  }
}

onMounted(() => {
  window.addEventListener("message", handleMessage);
});

onUnmounted(() => {
  window.removeEventListener("message", handleMessage);
});
</script>


<style lang="scss">
	*{
		margin: 0px;
		padding: 0px;
	}
</style>
